import React from 'react';
import { useEffect, useState } from 'react'
import Button from '../common/ui-components/input/Button';
import styles from '../../styles/modules/components/SelfServe/select-issue.module.scss';
import commonStyles from '../../styles/modules/components/SelfServe/phone-input-step.module.scss';
import { connect } from 'react-redux';
import UITextArea from "../common/ui-components/input/UITextArea";
import InvalidIssueAlert from "../../components/selfserve/InvalidIssueModal"
import {
    changeProgress,
    planCoversFetched,
    planIssuesFetched,
    updateSelectedProblems,
    changeTrackerState,
    changeAddressPageFrom,
    updateCustomIssue,
    pushToTicketList,
    previousStepProgress,
    updateCopaymentdetails,
    updateIsServicePgChargesApplicable,
} from '../../redux/actions/selfserveActions';
import { useDispatch } from 'react-redux';
import { selectIssues } from '../../tracking/selfserveTracking';
import DeviceDetail from '../selfserve/DeviceDetail';
import { HOMECARE_PLANS,HOMECARE_PLAN_LIST } from '../../constants/index';
import { getSortedProblems } from '../../constants/selfserve'
import { GetPlanCovers, GetCategoryIssues, GetCopaymentDetails } from '../../api/selfserve';
import { cleverTapTrigger } from '../../tracking/segment';
interface ReduxStateProps {
    selfserveReducer: any,
}

interface MainProps {
    setPageLoading: (data:Boolean) => void
}

type Props = ReduxStateProps & MainProps;


const SelectIssue = (props: Props) => {

    // main data from Redux store to render
    const dispatch:any = useDispatch();
    const { parentPlanDetails, categoryDetails, deviceDetails, editScreen } = props.selfserveReducer
    const { custom_issue } = props.selfserveReducer.serviceRequests[0]

    const [DataList, setDataList] = React.useState<any>([]);
    // handling user entered issues
    const [comment, setComment] = React.useState<string>(custom_issue ? custom_issue : "");
    // Enables modal when necessary
    const [enableModal, setEnableModal] = React.useState<boolean>(false);
    // Helps deciding modal state
    const [allInvalid, setAllInvalid] = React.useState<boolean>(false);
    // only decides buttons state
    const [problemsSelected, setProblemsSelected] = React.useState<any>(props.selfserveReducer.serviceRequests[0].selected_problems ? props.selfserveReducer.serviceRequests[0].selected_problems : []);
    const [problemsSelectedDetails, setProblemsSelectedDetails] = React.useState<any>(props.selfserveReducer.serviceRequests[0].selected_problems_details ? props.selfserveReducer.serviceRequests[0].selected_problems_details : []);
    const categoryType = props.selfserveReducer.planDetails.device_detail ? props.selfserveReducer.planDetails.device_detail.category_type : props.selfserveReducer.deviceDetails.category_type 
    const rootProductTypeID = props.selfserveReducer.serviceRequests[0].selected_cover ? props.selfserveReducer.serviceRequests[0].selected_cover.cover_details[0].root_product_type_id : '';
    const [hasCommentBoxRendered, setHasCommentBoxRendered] = useState<boolean>(false);
    const { previousStepList } = props.selfserveReducer

    useEffect(() => {
        const { planDetails } = props.selfserveReducer
        cleverTapTrigger('Raise SR Issue List Viewed', {'osid': planDetails?.osid, 'category': planDetails?.category, 'product_type': planDetails?.product_type})
        props.setPageLoading(true);
        dispatch(changeTrackerState(2));
        window.scrollTo({top:0,left:0,'behavior': 'smooth'})
        dispatch(changeAddressPageFrom(5));
        const { parentPlanDetails } = props.selfserveReducer
        if (props.selfserveReducer.planCovers.length === 0 && !HOMECARE_PLAN_LIST.includes(parentPlanDetails.plan_name)){
            const data = {
                "token_id": props.selfserveReducer.token_id,
                "osid": props.selfserveReducer.planDetails.osid
            }
            const covers: any = GetPlanCovers({
                "application": "website",
                "data": JSON.stringify(data)
            }).then((covers: any) => {
                dispatch(updateIsServicePgChargesApplicable(covers?.data?.is_service_pg_charges_applicable || false))

                const deviceId = props.selfserveReducer.planDetails.device_detail.device_id
                if (covers.data && covers.data.hasOwnProperty(deviceId)) {
                    dispatch(planCoversFetched(covers.data[deviceId]));
                }
            })
        }

        const {plan_name, hcb_serviced_devices, homecare_device_plan_list } = props.selfserveReducer.parentPlanDetails

        if(HOMECARE_PLANS.includes(plan_name) && !deviceDetails.device_id){
            const issueList = categoryDetails[deviceDetails.category_type].category_issues
            const List: any = getSortedProblems(issueList,rootProductTypeID);
            dispatch(planIssuesFetched(List));
            setDataList(List);
            props.setPageLoading(false);
        }else{
            const issueData = {
                // remove HardCoded Token once API issue solved
                "token_id": props.selfserveReducer.token_id,
                "category_types": [categoryType]
            }
            const issue: any = GetCategoryIssues({

                    "application": "website",
                    "data": JSON.stringify(issueData)

                }).then((issues: any) => {

                    // manipulating issues data
                    const issueList = issues.data[categoryType]
                    const List: any = getSortedProblems(issueList,rootProductTypeID);
                    setDataList(List);
                    dispatch(planIssuesFetched(List));
                    props.setPageLoading(false);
                })
        }

    }, [])



    // handles type event in textArea
    const handleSelectComment = (e) => {

        setComment(e.target.value);

    }

    const handleOnBlurComment = () => {

        // Adding User Custom Issue to redux Store

        dispatch(updateCustomIssue({index: 0, custom_issue:comment}));

    }

    // handles Click on issue
    const selectHandler = (item) => {

        const data = {
            index: 0,
            selectedProblems: problemsSelected,
            selectedProblemsDetails:problemsSelectedDetails
        }

        if (problemsSelected.includes(item.problem)) {

            // Remove from selected List ="problemsSelected"
            setProblemsSelected(
                [...problemsSelected].filter((items) => {
                    return items !== item.problem
                }
            ))
            setProblemsSelectedDetails(
                [...problemsSelectedDetails].filter((items) => {
                    return items.problem !== item.problem
                }
            ))

            data.selectedProblems = [...problemsSelected].filter((items) => { return items !== item.problem })
            data.selectedProblemsDetails = [...problemsSelectedDetails].filter((items) => {
                if(items.problem !== item.problem){
                    return items
                }
             })
            dispatch(updateSelectedProblems(data));

            if(item.problem === "Unable to identify the issue") {

                setComment("");
                dispatch(updateCustomIssue({index: 0, custom_issue:''}));
                setHasCommentBoxRendered(false);
            }

        } else {

            // add problem in selected List ="problemsSelected"
            setProblemsSelected(
                [...problemsSelected, item.problem]
            )
            setProblemsSelectedDetails(
                [...problemsSelectedDetails,item])

            data.selectedProblems = [...problemsSelected, item.problem]
            data.selectedProblemsDetails = [...problemsSelectedDetails, item]
            dispatch(updateSelectedProblems(data));
        }

    }

    // handles Next Button Logic
    const handleNextButton = () =>  {
        let oneInValid = false;
        let singleValid = false;

        [...DataList].forEach((obj) => {

                if(obj.is_valid) {

                    if(problemsSelected.includes(obj.problem)){
                        singleValid = true;
                        setAllInvalid(false);
                    }

                } else {
                    if(problemsSelected.includes(obj.problem)){
                        oneInValid = true
                        if(singleValid) {

                            setAllInvalid(false)

                        } else {

                            setAllInvalid(true)
                        }
                    }
                }
        })

        if (singleValid) {

            const data = {
                index: 0,
                selectedProblems: problemsSelected,
                selectedProblemsDetails: problemsSelectedDetails
            }
            // updating redux store for selected problems
            dispatch(updateSelectedProblems(data));

            if(problemsSelected.includes('Unable to identify the issue') ? comment : true){
                dispatch(updateCustomIssue({index: 0, custom_issue:comment}));
            }

            if (oneInValid){
                // will open modal for oneInvalid issue selected
                setEnableModal(true);

            } else {
                // will open modal for all invalid issues selected
                dispatch(pushToTicketList());
                if(HOMECARE_PLAN_LIST.includes(parentPlanDetails.plan_name)){
                  if(Object.values(props.selfserveReducer.appointmentProcessType).includes(null)) {
                    dispatch(changeProgress(15));
                  } else {
                    dispatch(changeProgress(8));
                  }
                }else{
                  dispatch(changeProgress(7));
                }
            }

        } else {

            // will open modal for all invalid issues selected
            setEnableModal(true);

        }
        if(props.selfserveReducer?.planDetails?.is_copay) {
            const data = {
                "token_id": props.selfserveReducer.token_id,
                'osid':props.selfserveReducer?.planDetails?.osid, 
                'selected_issues': problemsSelected
            }
            GetCopaymentDetails({'application': "website", 'data': JSON.stringify(data)})
            .then((res) => {
                dispatch(updateCopaymentdetails(res?.data))
            }).catch((err: any) => {
                console.log("Error", err)
            }) 
        }
        selectIssues(); //gtm tracking event
        cleverTapTrigger('Raise SR - Issues Selected', {'osid':props.selfserveReducer?.planDetails?.osid,'issues':problemsSelected.join(','), 'category': props.selfserveReducer?.planDetails?.category, 'product_type': props.selfserveReducer?.planDetails?.product_type});
    }
    const isCustomIssueSelected = problemsSelected.includes('Unable to identify the issue') ? true : false
    if (isCustomIssueSelected && !hasCommentBoxRendered) {
        let element = document.getElementById("otherIssueDesc");
        if(element) {
            element.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"})
            setHasCommentBoxRendered(true);
        }
    }

    return (
        <div className={styles.issue_parent}>

        <div className={commonStyles.top_heading}><h5>Select Issues</h5></div>

        {props.selfserveReducer.landed_on_page === 'issues' &&
                <DeviceDetail />
            }

            <ul>

                {DataList.length > 0 && DataList.map((item) => { return (<div className={styles.list_parent} key={item.problem_id}><li  onClick={() => selectHandler(item)} className={problemsSelected.includes(item.problem) ? styles.selected : ''.trim()}>{item.problem}</li>{problemsSelected.includes(item.problem) && !item.is_valid ? <span className={styles.error_message}>This issue is not covered for your Plan</span> : null}</div>) })}

            </ul>

            {problemsSelected.includes('Unable to identify the issue')? <UITextArea
                className={styles.inputs}
                value={comment}
                label='Other Issues'
                onChange={(e: any) => handleSelectComment(e)}
                onBlur = {() => handleOnBlurComment()}
                isRequired={true}
                id={'otherIssueDesc'}
                isAutoFocus={true}
            /> : null}


            <div className={commonStyles.button_actions_sticky} data-varient='sticky'>
            {previousStepList &&
                <Button
                    disabled={props.selfserveReducer.landed_on_page === 'issues'}
                    className={commonStyles.cart_btn}
                    text={'Previous'}
                    variant='secondary'
                    onClick={() => {
                        // dispatch(changeProgress(props.selfserveReducer.issuePageFrom));
                        dispatch(previousStepProgress());
                    }}
                />
                }
                <Button
                    disabled={(problemsSelected.length > 0 && (isCustomIssueSelected ? comment : true)) ? false : true}
                    className={commonStyles.cart_btn}
                    text={!editScreen.isEditing ? 'Next' : 'Done'}
                    variant='primary'
                    onClick={() => {handleNextButton()}}
                />

            </div>
            {/* //check invalidissueAlert with pranav and sandeep */}
            <InvalidIssueAlert
                is_open={enableModal}
                setEnableModal={setEnableModal}
                allInvalid={allInvalid}
                parentPlanDetails={parentPlanDetails}/>
        </div>
    )
}

const mapStateToProps = (state:any) => {
    return {
        selfserveReducer:state.selfserveReducer,
    }
}


export default connect<ReduxStateProps>(mapStateToProps) (SelectIssue);
